export const GET_EMPLOYERS = "GET_EMPLOYERS";
export const GET_EMPLOYERS_LOADING = "GET_EMPLOYERS_LOADING";
export const GET_EMPLOYERS_SUCCESS = "GET_EMPLOYERS_SUCCESS";
export const GET_EMPLOYERS_ERROR = "GET_EMPLOYERS_ERROR";

export const getEmployers = (body) => ({ type: GET_EMPLOYERS, body });